"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmDialog = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
exports.SmDialog = (0, react_1.forwardRef)((_a, ref) => {
    var _b;
    var { title, isOpen, isFull, children, className, headerRender, contentRender, footerRender, role = 'dialog', onOpen, onClose } = _a, props = __rest(_a, ["title", "isOpen", "isFull", "children", "className", "headerRender", "contentRender", "footerRender", "role", "onOpen", "onClose"]);
    const innerRef = (0, react_1.useRef)(null);
    const dialogClassnames = (0, classnames_1.default)('c-dialog__content', {
        '-full': isFull,
    }, className);
    (0, react_1.useImperativeHandle)(ref, () => innerRef.current);
    if (isOpen) {
        document.body.classList.add('o-pageScrollBlock');
        (_b = innerRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }
    else {
        document.body.classList.remove('o-pageScrollBlock');
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }
    return isOpen ? (react_1.default.createElement("div", { className: "c-dialog", tabIndex: -1 },
        react_1.default.createElement("div", { className: "c-dialog__backdrop", onClick: () => {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            } }),
        react_1.default.createElement("div", Object.assign({}, props, { "aria-modal": "true", className: dialogClassnames, 
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            tabIndex: 0, ref: innerRef, role: role, "aria-label": title, onKeyDown: (e) => {
                var _a;
                (_a = props.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(props, e);
                if (e.key === 'Escape') {
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                }
            } }),
            headerRender || (react_1.default.createElement("div", { className: "c-dialog__header mb-5" },
                react_1.default.createElement("h4", { className: "c-dialog__headerTitle" }, title),
                react_1.default.createElement("button", { type: "button", onClick: () => onClose === null || onClose === void 0 ? void 0 : onClose(), className: "c-hyperlink -iconOnly c-dialog__headerButton" },
                    react_1.default.createElement("span", { className: "material-icons" }, "close ")))),
            contentRender || react_1.default.createElement("div", { className: "c-dialog__box" }, children),
            footerRender))) : null;
});
//# sourceMappingURL=index.js.map